var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "swqI2SlaZWgv8qXkhwPKWa",
    x1: 32,
    x2: 32,
    y1: 7.5,
    y2: 56.752,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#swqI2SlaZWgv8qXkhwPKWa)",
    d: "M32,56c-1.077,0-2.046-0.555-2.591-1.484l-3.694-6.314c-0.759-1.299-2.099-2.185-3.675-2.432 c-9.479-1.482-16.37-9.85-16.027-19.462C6.371,16.213,15.083,8,25.432,8h13.137c10.349,0,19.061,8.213,19.419,18.308 c0.343,9.611-6.549,17.979-16.028,19.462c-1.575,0.247-2.915,1.133-3.674,2.432l-3.694,6.313C34.046,55.445,33.077,56,32,56z M25.432,10c-9.285,0-17.1,7.348-17.421,16.378C7.705,34.98,13.869,42.467,22.35,43.793c2.173,0.341,4.028,1.579,5.092,3.398 l3.694,6.313C31.397,53.952,31.827,54,32,54s0.603-0.048,0.864-0.496l3.694-6.313c1.063-1.819,2.919-3.058,5.091-3.398 c8.481-1.327,14.646-8.813,14.34-17.415C55.668,17.348,47.854,10,38.568,10H25.432z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "swqI2SlaZWgv8qXkhwPKWb",
    x1: 25,
    x2: 25,
    y1: 21.5,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#swqI2SlaZWgv8qXkhwPKWb)",
    d: "M25 21.998A3 3 0 1 0 25 27.998A3 3 0 1 0 25 21.998Z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "swqI2SlaZWgv8qXkhwPKWc",
    x1: 39,
    x2: 39,
    y1: 21.5,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#swqI2SlaZWgv8qXkhwPKWc)",
    d: "M39 21.998A3 3 0 1 0 39 27.998A3 3 0 1 0 39 21.998Z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "swqI2SlaZWgv8qXkhwPKWd",
    x1: 32,
    x2: 32,
    y1: 29.625,
    y2: 37.375,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#swqI2SlaZWgv8qXkhwPKWd)",
    d: "M36,30h-8c-0.552,0-1,0.446-1,0.998v1c0,2.761,2.239,5,5,5s5-2.239,5-5v-1 C37,30.446,36.552,30,36,30z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "swqI2SlaZWgv8qXkhwPKWe",
    x1: 32,
    x2: 32,
    y1: 7.5,
    y2: 56.752,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#swqI2SlaZWgv8qXkhwPKWe)",
    d: "M26 12H38V14H26z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.18a82d686efb5eb366cd036f1880ed32.svg";
export { ForwardRef as ReactComponent };